import { useTheme } from 'app/shopify';
import { isDarkColor } from 'app/utils/helpers';
import { StatusBar } from 'expo-status-bar';
import { Platform } from 'react-native';

export function CustomStatusBar() {
  const theme = useTheme();

  // Android only: use the header background color as the status bar color, to mimic the iOS behaviour
  if (Platform.OS !== 'android') return null;
  const isDark = isDarkColor(theme.colors['white-label.header.bg']);
  return <StatusBar style={isDark ? 'light' : 'dark'} />;
}
